<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/quick-view/shared/quick-view/quick-view.component.ts
-->
<ng-template #anchor />
